import React from 'react';
import {
    Input
} from 'shared/components/ui/input';
import {
    ProcedureStepList, OverviewSection
} from './OpcodeSimpleLeftPanel';
import SimpleTypedOutputsEditor from './components/SimpleTypedOutputsEditor';

/**
 * Simple-mode flow drill-in left column: procedure + output (header shows flow context).
 */
export default function OpcodeSimpleFlowPanel({
    flow,
    onFlowIdChange,
    steps,
    selectedStepIdx,
    onSelectStep,
    onAddStep,
    onRemoveStep,
    outputs,
    onOutputsChange,
    outputsOelContext
}) {
    const stepCount = (steps || []).length;

    return (
        <div className="border-t border-foreground/20">
            <OverviewSection title="Flow ID" hint="Referenced by Subflow and Choose steps">
                <Input
                    value={flow?.id || ''}
                    onChange={(e) => onFlowIdChange(e.target.value)}
                    placeholder="flow_name"
                    className="font-mono text-sm"
                />
            </OverviewSection>

            <OverviewSection
                title="Procedure"
                hint={stepCount
                    ? `${stepCount} step${stepCount === 1 ? '' : 's'} — select one to configure on the right`
                    : 'Add steps, then configure them on the right'}
            >
                <ProcedureStepList
                    steps={steps}
                    selectedStepIdx={selectedStepIdx}
                    onSelectStep={onSelectStep}
                    onAddStep={onAddStep}
                    onRemoveStep={onRemoveStep}
                    showEmptyCTAs={false}
                    emptyMessage=""
                    addButtonLabel="Add step"
                />
            </OverviewSection>

            <OverviewSection title="Output" hint="Map to a step inside this flow — e.g. @step_1.output.result (not @flow_id)">
                {stepCount === 0 ? (
                    <div className="px-1 py-2 text-xs leading-snug text-muted-foreground">
                        Add flow steps first, then map outputs here.
                    </div>
                ) : (
                    <SimpleTypedOutputsEditor
                        outputs={outputs}
                        onChange={onOutputsChange}
                        embedded
                        oelContext={outputsOelContext}
                        oelPlaceholder="@step_1.output.result"
                    />
                )}
            </OverviewSection>
        </div>
    );
}
